import React, { useContext } from 'react'
import LoggedInNavBar from '@Components/Navigations/NavBar/LoggedInNavBar'
import { StoresContext } from '@App/contexts'
import NotLoggedInNavBar from '@Components/Navigations/NavBar/NotLoggedInNavBar'
import { observer } from 'mobx-react'

const NavBar = () => {
    const { authStore } = useContext(StoresContext)
    return authStore.isLoggedIn ? <LoggedInNavBar /> : <NotLoggedInNavBar />
}

export default observer(NavBar)
